import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const sellScreenStyle = StyleSheet.create({
    outerContainer: {
        flex: 1,
        backgroundColor: appColors?.lightBackgroundColor,
    },
    outerContainerTwo: {
        flex: 1,
        backgroundColor: appColors?.lightBackgroundColor,
        paddingHorizontal: 10,
        paddingTop: 15,
        gap: 15
    },
    innerContainer: {
        flex: 1,
        flexDirection: "row"
    },
    landscapeView: {
        flex: 0.5,
    },
    portraitView: {
        position: "absolute",
        height: "100%",
        width: "100%",
        right: 0
    },
    checkoutOuterView: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1,
    },
    absoluteView: {
        height: "100%",
        width: "30%",
        backgroundColor: appColors?.transparentBackground
    },
    absoluteSecondView: {
        height: "100%",
        width: "70%",
        backgroundColor: appColors?.light,
        borderLeftWidth: 0.25,
        borderLeftColor: appColors?.lightGrey,
    },
    customHeaderView: {
        height: 75,
        backgroundColor: appColors?.light,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginHorizontal: 15
    },
    speedDialTextStyle: {
        fontFamily: appFonts?.medium,
        color: appColors?.dark,
        fontSize: fontSize?.errorFontSize
    },
    absoluteButton: {
        position: "absolute",
        backgroundColor: appColors.primary,
        width: 80,
        height: 80,
        borderRadius: 100,
        bottom: 30,
        right: 30,
        justifyContent: 'center',
        alignItems: "center"
    }
})